// @ts-ignore
import _ from 'lodash';
import { ajax } from 'utils';
import { PromiseAction } from '../types/promiseAction';
import * as api from 'services/javaApi';
import { PartnershipRequestInvoker } from '@purchase/supplier';
import { removeVendorStorage, setVendorStorage, getVendorStorage } from '@mpc/common/src/utils';

export const GET_USER_INFO_SUCCESS = 'mpc/account/get_user_info_success';
export const USER_LOGIN_OUT_SUCCESS = 'mpc/account/user_log_out_success';
export const GET_VENDOR_PROCESS_AUDIT_STATUS = 'mpc/account/get_vendor_process_audit_status';

export interface GetUserInfoSuccess {
  type: typeof GET_USER_INFO_SUCCESS;
  data?: object;
}
export interface UserLogoutSuccess {
  type: typeof USER_LOGIN_OUT_SUCCESS;
}

export type AccountActions = GetUserInfoSuccess | UserLogoutSuccess;

const setVendorRequestHeader = (result: any) => {
  const enterprises = result?.enterprises || [];
  // 设置默认供应商
  if (enterprises?.length) {
    let { vendorId: localVendorId, tenantCode: localTenantCode } = getVendorStorage();

    if (
      enterprises.some(
        (n: any) => n.vendorId === localVendorId && n.tenants?.some((t: any) => t.tenantCode === localTenantCode),
      )
    ) {
      return;
    }
    setVendorStorage(enterprises?.[0]?.vendorId || '', enterprises?.[0]?.tenants?.[0]?.tenantCode);
  }
};

/**
 * 获取用户信息的公共逻辑
 * 合并 getUserData 和 outsourceAccountsUserInfo 的结果
 */
async function fetchUserInfoData() {
  try {
    const { data: userDataResult } =
      (await PartnershipRequestInvoker.getInstance().partnerShipOpenApiAccountCurrentUser()) as any;

    setVendorRequestHeader(userDataResult);

    let userInfoResult = await api.outsourceAccountsUserInfo();

    let vendorProcess = null;
    // 接口成功之后才进行路由hash的判断
    if(userDataResult?.enterprises){
      const hash = window.location.hash;
      let { vendorId: localVendorId, tenantCode: localTenantCode } = getVendorStorage();
      // 新供应商才能请求供应商详情接口 
      if (localVendorId?.indexOf('NEV') > -1) {
        try {
          vendorProcess = await PartnershipRequestInvoker.getInstance().partnerShipOpenApiVendorCheckStatusDetail();
          if (!vendorProcess?.data?.onboarded) {
            if (!hash.includes('#/outCompanyManagement/outCompanyInfo')) {
              window.location.hash = '#/outCompanyManagement/outCompanyInfo';
              window.location.reload();
              return;
            }
          }
        } catch (error) {}
      } else {
        if (hash.includes('#/outCompanyManagement/outCompanyInfo')) {
          window.location.hash = '#/outWorkbenchPortal/outNormalPurchase/pendingQuotePortal';
          window.location.reload();
          return;
        }
      }
    }

    return {
      ...userInfoResult,
      // 将 currentUser 和 vendorProcessAudit 合并到 data 中，确保 reducer 能获取到
      data: {
        ...(userInfoResult?.data || {}),
        currentUser: userDataResult, // 将 getUserData 的返回值添加到结果中
        suppliersList: userDataResult?.enterprises || [],
        vendorProcessAudit: vendorProcess?.data,
      },
    };
  } catch (error: any) {
    return {
      res_code: 0,
      res_msg: error.message || '获取用户信息失败',
      data: null,
    };
  }
}

export function getUserInfo(): PromiseAction {
  return {
    types: [null, GET_USER_INFO_SUCCESS, null],
    promise: fetchUserInfoData,
  };
}

export function userLogin(body: any): PromiseAction {
  return {
    types: [null, null, null],
    promise: () =>
      api.outsourceSessionsLogin(body).catch((error: any) => {
        return {
          res_code: 0,
          res_msg: error.message,
        };
      }),
  };
}

export function userLogout(): PromiseAction {
  return {
    types: [null, USER_LOGIN_OUT_SUCCESS, null],
    promise: () =>
      PartnershipRequestInvoker.getInstance()
        .authLogout()
        .then(() => {
          removeVendorStorage();
        }),
  };
}

export function setLanguageTrunk(language: object) {
  return {
    types: [null, null, null],
    promise: () =>
      ajax({
        url: 'v1/accounts/set_language',
        method: 'POST',
        body: { language },
      }),
    language,
  };
}

export function setLanguage(language: object) {
  return (dispatch: any, getState: any) => {
    const id = _.get(getState(), `account.id`);
    return dispatch(setLanguageTrunk(language)).then((res: any) => {
      if (res.res_code === 1) {
        dispatch(getUserInfo(id));
      }
    });
  };
}

export function modifyPwd(body: any): PromiseAction {
  return {
    types: [null, null, null],
    promise: () => api.outsourceSessionsModifyPassword(body),
  };
}

export function forgetPwd(body: any): PromiseAction {
  return {
    types: [null, null, null],
    promise: () =>
      api.outsourceSessionsForgetPassword(body).catch((error: any) => {
        return {
          res_code: 0,
          res_msg: error.message,
        };
      }),
  };
}

export function resetPwd(body: any): PromiseAction {
  return {
    types: [null, null, null],
    promise: () =>
      api.outsourceSessionsResetPassword(body).catch((error: any) => {
        return {
          res_code: 0,
          res_msg: error.message,
        };
      }),
  };
}

export function checkLink(body: any): PromiseAction {
  return {
    types: [null, null, null],
    promise: () =>
      api.outsourceSessionsCheckResetLink(body).catch((error: any) => {
        return {
          res_code: -1,
          res_msg: error.message,
        };
      }),
  };
}

export function isOpenNotification(flag: boolean) {
  return (dispatch: any) => {
    return dispatch({
      type: 'flag',
      data: flag,
    });
  };
}
